<template>
  <div class="not-found">
    <div class="navigation-spacer"></div>
    <div class="container page-component text-center">
      <h1>404</h1>
      <p>Page not found</p>
      <a class="btn btn-large btn-primary" href="/">Home</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
